import { render, staticRenderFns } from "./SplitScreenTab.vue?vue&type=template&id=f2447d86&scoped=true&"
import script from "./SplitScreenTab.vue?vue&type=script&lang=js&"
export * from "./SplitScreenTab.vue?vue&type=script&lang=js&"
import style0 from "./SplitScreenTab.vue?vue&type=style&index=0&id=f2447d86&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2447d86",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VHover } from 'vuetify/lib/components/VHover';
import { VImg } from 'vuetify/lib/components/VImg';
import { VList } from 'vuetify/lib/components/VList';
import { VListItem } from 'vuetify/lib/components/VList';
import { VMenu } from 'vuetify/lib/components/VMenu';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VProgressLinear } from 'vuetify/lib/components/VProgressLinear';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCol,VHover,VImg,VList,VListItem,VMenu,VProgressCircular,VProgressLinear,VRow})


/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src904045295/src/ueyes-front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f2447d86')) {
      api.createRecord('f2447d86', component.options)
    } else {
      api.reload('f2447d86', component.options)
    }
    module.hot.accept("./SplitScreenTab.vue?vue&type=template&id=f2447d86&scoped=true&", function () {
      api.rerender('f2447d86', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/camera-group/SplitScreenTab.vue"
export default component.exports